module.exports = __webpack_public_path__ + "img/rt-outdoor.66de19be.png";